import {Card, CardActions, Stack, styled} from '@mui/material';
import {CardProps} from './types';

const StyledCard = styled(Card)<CardProps>`
	display: flex;

	${({$showAsBanner}) =>
		!$showAsBanner &&
		`
		flex-direction: column;
    `}
`;

const StyledImageContainer = styled('div')<CardProps>`
	${({$showAsBanner}) =>
		$showAsBanner &&
		`
        max-width: 187px;

        img {
            height: auto;
        }
    `}
`;

const StyledInfoContainer = styled(Stack)<CardProps>`
	justify-content: space-between;

	${({$showAsBanner}) =>
		$showAsBanner &&
		`
        flex-direction: row;
        align-items: center;
    `}
`;

const StyledCardActions = styled(CardActions)<CardProps>`
	padding: 8px 16px 16px;

	${({$showAsBanner}) =>
		$showAsBanner &&
		`
        padding: 0px 16px 0px 0px;
    `}
`;

export {StyledCard, StyledImageContainer, StyledCardActions, StyledInfoContainer};
